import Tags from 'components/Tags';
import { useParams } from 'react-router-dom';
import { SectionTitle } from '../styled';
import { NoTagsMessage } from './styled';

interface SessionTagsProps {
    tags: string[];
}

const SessionTags = ({ tags }: SessionTagsProps) => {
    const { agentId } = useParams();
    return (
        <div className="rainbow-flex_column">
            <SectionTitle>Tags</SectionTitle>
            {tags.length > 0 ? (
                <Tags
                    value={tags}
                    agentId={agentId as string}
                    entity="call"
                    maxBadges={3}
                />
            ) : (
                <NoTagsMessage>No tags added.</NoTagsMessage>
            )}
        </div>
    );
};

export default SessionTags;
